// Users reach the back office with the User model's own fields (name, surname, company).
// Shown as "First Last", or the company when the user has no name.
export type UserNameFields = { name?: string; surname?: string; company?: string };

export const userDisplayName = (user?: UserNameFields | null): string =>
    [user?.name, user?.surname].filter(Boolean).join(' ') || user?.company || '';
